import { defineMessages } from 'react-intl';

const messages: {
	draftVersion: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	liveVersion: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	versionNumber: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	draftVersion: {
		id: 'ai-mate.chat-header.version-lozenge.draft-version',
		defaultMessage: 'Draft',
		description: 'Label for draft version lozenge shown next to the agent name',
	},
	liveVersion: {
		id: 'ai-mate.chat-header.version-lozenge.live-version',
		defaultMessage: 'Live',
		description: 'Label for live version lozenge shown next to the agent name',
	},
	versionNumber: {
		id: 'ai-mate.chat-header.version-lozenge.version-number',
		defaultMessage: 'V{versionNumber}',
		description: 'Label showing the version number in the header lozenge, e.g. V1, V2',
	},
});

export default messages;
